import type {
  NavigationScope,
  NavigationScopeState,
  ParametersDefinition,
  StateDefinition,
} from "@otto-ec/global-resources/navigation";
import type { OcSheetV1Props } from "../SheetV1.types.g";
import { sheetScope } from "../utils/props";
import { sheetTagName } from "../utils/consts";

export const navScope = /*           */ sheetScope.scope("navigation");

/**
 *
 */
export const statePropStack = "historyStack" as const;
/**
 *
 *
 */
export const statePropOnLoad = "openOnLoad" as const;
/**
 *
 */
export const statePropId = "currentId" as const;
/**
 *
 *
 */
export const statePropConfig = "currentConfig" as const;

/**
 *
 *
 */
export type SheetHistoryState = {
  /**
 *
 */
  [statePropStack]?: string[];

  /**
 *
 *
 */
  [statePropOnLoad]?: boolean;

  /**
 *
 */
  [statePropId]?: string;

  /**
 *
 *
 */
  [statePropConfig]?: OcSheetV1Props;
};

type SheetScopeOptions = {
  hash: ParametersDefinition<{ [sheetTagName]: string }, true>;
  state: StateDefinition<SheetHistoryState>;
};

/**
 *
 */
export type SheetNavScope = NavigationScope<typeof sheetTagName, SheetScopeOptions>;

export type SheetNavState = NavigationScopeState<SheetScopeOptions>;

export const scopeInfo = { info: sheetTagName };
